export default {
  name: "WalkIn",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M22.5 27h-2v-5c0-.33-.17-.65-.44-.83l-4.36-2.9v-6.28c2.39-.12 4.3-2.08 4.3-4.49C20 5.02 17.98 3 15.5 3S11 5.02 11 7.5c0 1.62.87 3.03 2.16 3.83l-4.37 3.38c-.25.19-.39.48-.39.79V20c0 .55.45 1 1 1s1-.45 1-1v-4.01l3.3-2.55v5.36c0 .33.17.65.44.83l4.35 2.9V28c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.44-1-.99-1zm-7-22a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5zm.07 17.51c.27.48.1 1.09-.39 1.36l-4.69 2.61V28c0 .55-.45 1-1 1s-1-.45-1-1v-2.1c0-.36.2-.7.51-.87l5.2-2.9c.5-.27 1.11-.1 1.37.38zM18 13.7h3.5c.55 0 1 .45 1 1s-.45 1-1 1H18c-.55 0-1-.45-1-1s.45-1 1-1z",
  },
}
